import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-cart-mileage-list',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareCartMileageList {
    @Event() valueChange: EventEmitter;
    @Prop() options: { label: string, value: string, info?: string }[] = [];
    @Prop() value: string = '';
    @Prop() distanceUnitAbbreviation: string;

    handleOptionChange(e, item) {
        e.preventDefault();
        this.valueChange.emit(item);
    }

    mappedOption = (item) => {
        const itemCLass = item.value === this.value &&
            "list-item selected" ||
            "list-item";

        return (
            <div
                class={itemCLass}
                onClick={(e) => this.handleOptionChange.call(this, e, item)}
            >

                <RadioButton
                    label={item.label}
                    checked={item.value === this.value}
                    onChange={(e) => this.handleOptionChange.call(this, e, item)}
                />

                <span class="info">
                   {item.info}
                </span>
            </div>
        );
    }

    render() {
        return (
            <div class="wrapper">
                {this.options.map(this.mappedOption)}
            </div>
        );
    }
}

const RadioButton = ({ label, checked, onChange, ...rest }) => {
    return (
        <label class="container" {...rest}>
            <span>{label}</span>
            <input type="radio" checked={checked} name="radio" onChange={onChange} />
            <span class="checkmark" />
        </label>
    );
}
